"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.memoryCache = function () {
  var memoryCacheBucket = {};

  var set = function set(key, value) {
    memoryCacheBucket[key] = value;
  };

  var get = function get(key) {
    if (memoryCacheBucket.hasOwnProperty(key)) {
      return memoryCacheBucket[key];
    }
  };

  return {
    set: set,
    get: get
  };
};